module.exports = __webpack_public_path__ + "img/logo_white_skanticket.539ebd9a.png";